import React, { useContext } from "react";
import { HighlightAlt } from "@mui/icons-material";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";

/**
 * Polygon passing mode allows for the user to draw a temporary polygon
 * that can be then used to perform actions related to the polygon.
 *
 * For example, Market lens uses this polygony to identify the subareas.
 *
 * @returns Button to switch to polygon passing draw mode
 */
const PolygonPassingModeButton: React.FC<IButtonProps> = ({ title = "Select area" }) => {
  const { map, drawControl } = useContext(MapContext);

  const handleOnClick = () => {
    drawControl.current.changeMode("passing_draw_polygon");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "passing_draw_polygon" });
  };

  return (
    <ToolbarToggleButton title={title} value="passing_draw_polygon" onClick={handleOnClick}>
      <HighlightAlt />
    </ToolbarToggleButton>
  );
};

export default PolygonPassingModeButton;
